import { ref, computed, watchEffect } from "vue";
import Request from "@/services/request";
import {
  DEAL_TEMPLATE_DOWNLOAD_HISTORY,
  DEAL_UPLOAD_HISTORY,
} from "@/utils/enum/endpoints";
const Req = new Request();
import store from "@/store";
const DEFAULT_PAGE_COUNT = -1;
const DEFAULT_RESULT_COUNT = -1;

export default function useBulkDealService(tableType, pagination) {
  const data = ref([]);
  const totalResultCount = ref(DEFAULT_RESULT_COUNT);
  const error = ref(null);
  const isLoading = ref(false);
  const request = ref(null);
  const pageCount = ref(DEFAULT_PAGE_COUNT);

  const requestParams = computed(() => {
    const { pageIndex } = pagination.value;
    const currentPage = pageIndex;

    return {
      page: currentPage,
    };
  });

  watchEffect(() => {
    isLoading.value = true;
    let endpoint = null;
    switch (tableType) {
      case "template-table":
        endpoint = DEAL_TEMPLATE_DOWNLOAD_HISTORY;
        break;
      case "file-table":
        endpoint = DEAL_UPLOAD_HISTORY;
        break;
    }
    const sellerId = store.getters["auth/getSellerId"];
    request.value = Req.get(
      endpoint.replace("{id}", sellerId),
      requestParams.value
    )
      .then(async (response) => {
        if (response.status === 200) {
          if (tableType === "template-table") {
            data.value = response.data.bulkProductDealTemplateDtoList || [];
            totalResultCount.value =
              response.data.pagingModel?.totalCount || DEFAULT_RESULT_COUNT;
            pageCount.value =
              response.data.pagingModel?.pageCount || DEFAULT_PAGE_COUNT;
          } else if (tableType === "file-table") {
            data.value = response.data.bulkProductDealDtos || [];
            totalResultCount.value =
              response.data.pagingModel?.totalCount || DEFAULT_RESULT_COUNT;
            pageCount.value =
              response.data.pagingModel?.pageCount || DEFAULT_PAGE_COUNT;
          }
          error.value = null;
        } else {
          throw new Error("Network response was not OK");
        }
      })
      .catch((err) => {
        error.value = err || null;
        data.value = null;
        totalResultCount.value = DEFAULT_RESULT_COUNT;
        pageCount.value = DEFAULT_PAGE_COUNT;
      })
      .finally(() => {
        isLoading.value = false;
      });
  });

  return {
    data,
    totalResultCount,
    pageCount,
    error,
    isLoading,
  };
}
